import { render, staticRenderFns } from "./ManagerProfile.vue?vue&type=template&id=53d84982&scoped=true"
import script from "./ManagerProfile.vue?vue&type=script&lang=js"
export * from "./ManagerProfile.vue?vue&type=script&lang=js"
import style0 from "./ManagerProfile.vue?vue&type=style&index=0&id=53d84982&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d84982",
  null
  
)

export default component.exports